module.exports = __webpack_public_path__ + "static/img/logo.2b90ba1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = BvKS
// module chunks = 1